export var OrganisationTypeAnswerValue = /* @__PURE__ */ ((OrganisationTypeAnswerValue2) => {
  OrganisationTypeAnswerValue2["LimitedLiability"] = "LimitedLiability";
  OrganisationTypeAnswerValue2["UnlimitedLiability"] = "UnlimitedLiability";
  OrganisationTypeAnswerValue2["SharedLiability"] = "SharedLiability";
  return OrganisationTypeAnswerValue2;
})(OrganisationTypeAnswerValue || {});
